import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const SiteFooter = () => {

    return (
        <footer style={{ color: 'white' }}>
            <div className='site-footer-top'>
                <Container>
                    <Row>
                        <Col>
                            <h4>Krishna Prints Solution</h4>
                            Krishna Prints Solution Private Limited 
                            is a Private incorporated on 10 September 2020
                        </Col>
                        <Col>
                            <h4>Quick Links</h4>
                            <Link to='home'>Home</Link><br />
                            <Link to='about-us'>About Us</Link><br />
                            <Link to='services'>Services</Link><br />
                            <Link to='contact-us'>Contact Us</Link><br />
                        </Col>
                        <Col>
                            <strong>Email</strong><br />
                            krishnadigitalprint@gmail.com<br />
                            shreekrishnazerox@gmail.com
                            <br/><br/>
                            <strong>Call</strong><br />
                            Phone +91 8080387206</Col>
                        <Col>
                            <address>
                                <strong>Address</strong><br />
                                724/4, Malawani 4 No.,<br />
                                Opp Malawani Police Station,<br />
                                Mumbai – 400095. Maharashtra, India
                            </address>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='site-footer-bottom'>
                <Container>
                    <Row className="justify-content-center">
                        <Col>Copyright © 2024. All Rights Reserved.</Col>
                    </Row>
                </Container>
            </div>
        </footer>
    )
}

export default SiteFooter